export const FEATURE_FLAG_KEYS = Object.freeze({
  WEBINAR_GRAVADO: "aqat-webinar-gravado",
  WHATSAPP_BUTTON: "whatsapp-button",
} as const);

export type FeatureFlagKey =
  (typeof FEATURE_FLAG_KEYS)[keyof typeof FEATURE_FLAG_KEYS];
